<div class="payment-page">
  <div class="payment-header">
    <button
      type="button"
      class="back-btn"
      (click)="goBack.emit()"
      aria-label="Go back"
    >
      ←
    </button>
    <h2 class="payment-title">Complete Payment</h2>
    <span class="secure-badge">🔒 100% Secure</span>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-12 gap-5 payment-body">
    <!-- LEFT -->
    <div class="md:col-span-3 payment-methods">
      <div
        class="method-card"
        [class.active]="selectedPaymentCard === 'online'"
        (click)="selectPaymentCard('online')"
      >
        <div class="method-icon">💳</div>
        <div class="method-info">
          <div class="method-title">Pay Online</div>
          <div class="method-sub">
            UPI, Cards, Netbanking, Wallets · ₹{{ onlineTotal }}
          </div>
        </div>
      </div>

      <div
        class="method-card"
        [class.active]="selectedPaymentCard === 'cod'"
        (click)="selectPaymentCard('cod')"
      >
        <div class="method-icon">₹</div>
        <div class="method-info">
          <div class="method-title">Cash on Delivery</div>
          <div class="method-sub">₹{{ codTotal }}</div>
        </div>
      </div>
    </div>

    <!-- MIDDLE -->
    <div class="md:col-span-6 payment-action-panel">
      <div
        class="online-payment-panel"
        *ngIf="selectedPaymentCard === 'online'"
      >
        <div class="payment-panel-header">
          <h3>Pay Online</h3>
          <p>
            Pay securely with UPI, card, netbanking or wallet using Razorpay.
          </p>
        </div>

        <div class="payment-error" *ngIf="paymentMessage">
          {{ paymentMessage }}
        </div>

        <button
          type="button"
          class="place-order-btn"
          [disabled]="loading || isProcessing"
          (click)="startOnlinePayment()"
        >
          {{ loading ? "Processing..." : "Pay ₹" + grandTotal }}
        </button>
      </div>

      <div class="cod-payment-panel" *ngIf="selectedPaymentCard === 'cod'">
        <div class="payment-panel-header">
          <h3>Pay on Delivery</h3>
          <p>Pay when your order is delivered to you.</p>
        </div>
        <p class="handling-note">
          Due to handling costs, a nominal fee of ₹{{ COD_HANDLING_FEE }} will
          be charged for orders placed using this option. Avoid this fee by
          paying online now.
        </p>
        <button
          type="button"
          class="place-order-btn mt-5"
          [disabled]="isProcessing"
          (click)="placeCodOrder()"
        >
          {{ isProcessing ? "Processing..." : "Place Order" }}
        </button>
      </div>
    </div>

    <!-- RIGHT: keep your existing .order-summary block unchanged -->

    <div class="md:col-span-3 order-summary">
      <div class="summary-row summary-mrp">
        <span> MRP (incl. of all taxes) </span> <span> ₹{{ mrpAmount }} </span>
      </div>
      <!-- FEES -->
      <div class="summary-section-header" (click)="toggleFees()">
        <span> Fees </span>
        <span class="chevron"> {{ feesExpanded ? "⌃" : "⌄" }} </span>
      </div>
      <div class="summary-details" *ngIf="feesExpanded">
        <div class="summary-row" *ngIf="paymentHandlingFee > 0">
          <span class="underline-dashed"> Payment Handling Fee </span>
          <span> ₹{{ paymentHandlingFee }} </span>
        </div>
        <div class="summary-row">
          <span> Platform Fee </span> <span> ₹{{ PLATFORM_FEE }} </span>
        </div>
      </div>
      <!-- DISCOUNTS -->
      <ng-container *ngIf="totalDiscounts > 0">
        <div class="summary-section-header" (click)="toggleDiscounts()">
          <span> Discounts </span>
          <span class="chevron"> {{ discountsExpanded ? "⌃" : "⌄" }} </span>
        </div>
        <div class="summary-details" *ngIf="discountsExpanded">
          <div class="summary-row" *ngIf="mrpDiscount > 0">
            <span> MRP Discount </span>
            <span class="discount-value"> -₹{{ mrpDiscount }} </span>
          </div>
          <div class="summary-row" *ngIf="couponDiscount > 0">
            <span> Coupon Discount </span>
            <span class="discount-value"> -₹{{ couponDiscount }} </span>
          </div>
        </div>
      </ng-container>
      <hr />
      <!-- TOTAL -->
      <div class="summary-row total-row">
        <span> Total Amount </span> <span> ₹{{ grandTotal }} </span>
      </div>
    </div>
  </div>
</div>
